import { MemberRole } from 'src/features/member/types'

export const canUseVideoCallConnectionTest = (role: MemberRole) => {
  return role === 'Dr' || role === 'CRC'
}
